interface ServiceAreaEntry {
  city: string;
  district: string;
}

let cachedAreas: ServiceAreaEntry[] | null = null;

export async function getServiceAreas(): Promise<ServiceAreaEntry[]> {
  if (cachedAreas && cachedAreas.length > 0) return cachedAreas;
  try {
    const res = await fetch('/api/service-areas');
    if (!res.ok) return cachedAreas || [];
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      cachedAreas = data.map((a: ServiceAreaEntry) => ({ city: a.city, district: a.district }));
    }
    return cachedAreas || [];
  } catch {
    return cachedAreas || [];
  }
}

export function invalidateServiceAreaCache() {
  cachedAreas = null;
}

/**
 * 주소 문자열에서 시(도)와 구를 추출
 * 카카오 우편번호 API는 짧은 형태("서울 관악구")와 긴 형태("서울특별시 관악구") 모두 반환 가능
 * 경기도 성남시 분당구 → city="성남시", district="분당구"
 */
function parseCityDistrict(address: string): { city: string; district: string } | null {
  // "경기도 성남시 분당구" 등 도+시+구 패턴 우선
  const match3 = address.match(/[가-힣]+(?:도|특별자치도)\s+([가-힣]+시)\s+([가-힣]+구)/);
  if (match3) return { city: match3[1], district: match3[2] };

  // "서울 관악구" / "서울특별시 관악구" 패턴
  const match2 = address.match(/([가-힣]+(?:특별시|광역시|특별자치시|시)?)\s+([가-힣]+구)/);
  if (match2) {
    const city = match2[1].replace(/특별시|광역시|특별자치시$/, '');
    return { city, district: match2[2] };
  }

  return null;
}

/**
 * 주소가 서비스 가능 지역인지 확인 (비동기)
 */
export async function checkServiceArea(address: string): Promise<{ available: true } | { available: false; city: string; district: string }> {
  const areas = await getServiceAreas();
  const parsed = parseCityDistrict(address);
  if (!parsed) return { available: true };

  const isAvailable = areas.some(
    (a) => parsed.city.startsWith(a.city) && parsed.district === a.district
  );

  if (isAvailable) return { available: true };
  return { available: false, city: parsed.city, district: parsed.district };
}
